import { render, staticRenderFns } from "./_base-email-picker.vue?vue&type=template&id=423705eb&scoped=true&"
import script from "./_base-email-picker.vue?vue&type=script&lang=js&"
export * from "./_base-email-picker.vue?vue&type=script&lang=js&"
import style0 from "./_base-email-picker.vue?vue&type=style&index=0&id=423705eb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423705eb",
  null
  
)

export default component.exports